import {DesignSystem, DesignSystemTiming} from "../../../engine/_interfaces/designSystem";
import process from '../../../engine/design-system/motion/timing-to-placeholders';

const params: DesignSystemTiming = {
  'x-fast': 100,
  'fast': 250,
  'std': 500,
  'slow': 1000,
  'x-slow': 2000,
};

const designSystem: DesignSystem = {
  _EXPORT: process,
  _NAME: 'Timing',
  params,
};

export default designSystem;
